"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var ApiConfig_1 = require("../config/ApiConfig");
var ApiManager_1 = require("../ApiManager");
var ApiComic = /** @class */ (function (_super) {
    __extends(ApiComic, _super);
    function ApiComic() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.GET_HOME_DATA_URL = '/api/v1/page/main';
        _this.GET_DAILY_DATA_URL = '/api/v1/page/daily';
        _this.GET_COMIC_DATA_URL = '/api/v1/page';
        _this.GET_COMIC_BINGE_URL = '/api/v1/page/binge';
        _this.GET_HASHTAG_COMIC_DATA_URL = '/api/v1/hashtag';
        _this.GET_COMIC_ALL = 'api/v1/search/totalsearch';
        _this.GET_PREVIEW = '/api/v1/page/preview';
        /**
         * 메인 page api
         * @param request
         * @returns
         */
        // public getHomeData = (
        //   token: string,
        //   isAlreadyMature: boolean,
        //   is17: boolean,
        //   isRemake: boolean,
        // ) => {
        //   return Axios.Client<null>({
        //     header: { token, isRemake, isAlreadyMature, is17 },
        //     method: 'get',
        //     url: this.GET_HOME_DATA_URL,
        //   });
        // };
        _this.getHomeData = function (token, isRemake) {
            return ApiConfig_1.Axios.Client({
                header: { token: token, isRemake: isRemake },
                method: 'get',
                url: _this.GET_HOME_DATA_URL,
            });
        };
        /**
         * 연재 page api
         * @param request
         * @param week
         * @returns
         */
        _this.getDailyData = function (token, is17, week) {
            var param = week === 'TOP' ? 'popular' : week;
            return ApiConfig_1.Axios.Client({
                header: { token: token, is17: is17 },
                method: 'get',
                url: "".concat(_this.GET_DAILY_DATA_URL, "/").concat(param),
            });
        };
        /**
         * main comic list page api
         * @param token : 로그인 상태 인증값
         * @param category : complete/new/ranking
         * @returns : comicList
         */
        _this.getComicData = function (token, is17, category) {
            return ApiConfig_1.Axios.Client({
                header: { token: token, is17: is17 },
                method: 'get',
                url: "".concat(_this.GET_COMIC_DATA_URL, "/").concat(category),
            });
        };
        /**
         * hashTag 상세페이지 api
         * @param request
         * @param name
         * @returns
         */
        _this.getHashTagComicData = function (token, is17, name, type) {
            var data = {
                name: name,
                type: type,
            };
            return ApiConfig_1.Axios.Client({
                header: { token: token, is17: is17 },
                method: 'post',
                url: _this.GET_HASHTAG_COMIC_DATA_URL,
                data: data,
            });
        };
        /**
         * 검색용 comic data
         * @param token
         * @param language
         * @param mature
         * @returns
         */
        _this.getComicAllData = function (token, mature, is17) {
            return ApiConfig_1.Axios.Client({
                header: { token: token, mature: mature, is17: is17 },
                url: _this.GET_COMIC_ALL,
                method: 'get',
            });
        };
        /**
         * binge page api
         * @param token
         * @param language
         * @returns
         */
        _this.getBingeData = function (token) {
            return ApiConfig_1.Axios.Client({
                header: { token: token },
                url: _this.GET_COMIC_BINGE_URL,
                method: 'get',
            });
        };
        /**
         * 오픈예정 작품 리스트
         * @param token
         * @param language
         * @returns
         */
        _this.getPreViewData = function (token) {
            return ApiConfig_1.Axios.Client({
                header: { token: token },
                url: _this.GET_PREVIEW,
                method: 'get',
            });
        };
        return _this;
    }
    ApiComic.getInstance = function (initValue) {
        if (!ApiComic.classInstance) {
            this.classInstance = new ApiComic(initValue);
        }
        return this.classInstance;
    };
    return ApiComic;
}(ApiManager_1.ApiManager));
exports.default = ApiComic;
